import { render, staticRenderFns } from "./page-dropdown.vue?vue&type=template&id=0a1aad51&scoped=true&"
import script from "./page-dropdown.js?vue&type=script&lang=js&"
export * from "./page-dropdown.js?vue&type=script&lang=js&"
import style0 from "./page-dropdown.scss?vue&type=style&index=0&id=0a1aad51&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1aad51",
  null
  
)

export default component.exports